import { format, parse } from "date-fns"

const formatDateStringToYYMMDD = (dateString: string): string => {
  const date = parse(dateString, "yyyy-MM-dd", new Date())

  return format(date, "yyMMdd")
}

export default formatDateStringToYYMMDD
